import angular from 'angular';
import _ from 'lodash';

angular.module('fidelityNew', ['application']).config(["$stateProvider", "$translatePartialLoaderProvider", function($stateProvider: any, $translatePartialLoaderProvider: any) {
    $translatePartialLoaderProvider.addPart('fidelity');

    $stateProvider.state('app.new.fidelity', {
        url: '/fidelity',
        template: `<fidelity-module></fidelity-module>`,
    });


    $stateProvider.state('app.new.fidelity.campaigns', {
        url: '/campaigns',
    });

    $stateProvider.state('app.new.fidelity.rules', {
        url: '/rules',
    });

    $stateProvider.state('app.new.fidelity.prizes', {
        url: '/prizes',
    });
}]);